import useSnackbar from '@/hooks/snackbars.js';
import { changeTicketStatus, getCourseTicketsList, getTicket } from '@/api/ticketApi.js';

const { createSnackbar } = useSnackbar();

export default {
    namespaced: true,
    state: {
        data: null,
        loading: true,
    },
    getters: {
        loading: state => state.loading,
        appealsData: state => state.data,
        appeals: state => state.data?.data,
        appealsCount: state => state.data?.meta?.total,
        currentPage: state => state.data?.meta?.current_page,
        lastPage: state => state.data?.meta?.last_page,
    },
    mutations: {
        setAppealsData(state, data) {
            state.data = data;
        },
        appendAppealsData(state, data) {
            state.data = {
                ...data,
                data: [...state.data.data, ...data.data],
            };
        },
        patchAppeal(state, appeal) {
            state.data.data = state.data.data.map(item => {
                if (item.id === appeal.id) return appeal;

                return item;
            });
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        resetAppealsState({ commit }) {
            commit('setAppealsData', null);
            commit('setLoading', true);
        },

        async fetchAppeals({ commit }, { versionId, params, isReplaceContent } = {}) {
            if (!versionId) return;

            commit('setLoading', true);

            try {
                const { data } = await getCourseTicketsList({
                    courseId: versionId,
                    params,
                });

                if (isReplaceContent) commit('setAppealsData', data);
                else commit('appendAppealsData', data);
            } catch (error) {
                console.error(error);
                createSnackbar({
                    type: 'error',
                    message: 'Ошибка загрузки. Попробуйте еще раз',
                });
            } finally {
                commit('setLoading', false);
            }
        },

        async updateAppealStatus({ commit }, { appealId, status } = {}) {
            try {
                const { data } = await changeTicketStatus(appealId, status);

                commit('patchAppeal', data.data);
            } catch (error) {
                console.error(error);
                createSnackbar({
                    type: 'error',
                    message: 'Ошибка изменения статуса обращения. Попробуйте еще раз',
                });
            }
        },

        async updateAppeal({ commit }, { appealId }) {
            try {
                const { data } = await getTicket(appealId);

                commit('patchAppeal', data.data);
            } catch (error) {
                console.error(error);
            }
        },
    },
};
